export const getOldBrowserHtml = (title, msg) => `
      <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <style>
          .link, .link:visited, .link:active{
              color: inherit;
          }
          .link:hover{
              text-decoration: none;
          }
        </style>
        <h1 style="font-size: 20px; font-weight: 600; text-align: center; line-height: 32px; color: black; text-transform: uppercase; padding: 0; margin: 0;">${title}</h1>
        <p style="padding: 0; margin: 0;">${msg}</p>
      </div>
`;
